module.exports = __webpack_public_path__ + "img/right-cloud.8a9d9bb4.png";